module.exports = __webpack_public_path__ + "static/img/4539_phase_function_Paper_PointsHejduk_Prediction.48bf254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4539_phase_function_Paper_PointsHejduk_Prediction.png
// module id = +8OK
// module chunks = 0